import { Form, Input, Row, Col, Switch, Select, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [calcModeData, setCalcModeData] = useState<any>();
    const [expiryRuleData, setExpiryRuleData] = useState<any>();
    const [balanceLock, setBalanceLock] = useState<boolean>(false);
    const [giftsLock, setGiftsLock] = useState<boolean>(false);
    const [pointsLock, setPointsLock] = useState<boolean>(false);
    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { isBalanceLock, isGiftsLock, isPointsLock } = res.data;
                setBalanceLock(!isBalanceLock);
                setGiftsLock(!isGiftsLock);
                setPointsLock(!isPointsLock);
            }
        })

        fetchApi.GET(defaultService,
            {
                apiId: 'generalData',
                apiVariable: 'calcMode@expiryRule',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { calcMode, expiryRule } = res.data;
                    setCalcModeData(calcMode);
                    setExpiryRuleData(expiryRule);
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'membershipRechargeLockRules',
        serviceId: 'business',
        displayOptions: {
            width: 900
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={8}>
                    <Form.Item
                        label="ID"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>
                </Col>

                <Col span={13}>
                    <Form.Item
                        label="规则"
                        name="ruleName"
                        rules={[{ required: true, message: '规则名称!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={3}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="余额锁定"
                        name="isBalanceLock"
                        tooltip='是否使用余额锁定功能'
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch checked={false}
                            onChange={(e) => { setBalanceLock(!e) }}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="余额模式"
                        name="balanceCalcModeId"
                        tooltip='锁定余额的计算模式'
                        rules={[{ required: !balanceLock, message: '请选择余额模式!' }]}>
                        <Select
                            showSearch
                            placeholder="余额模式"
                            optionFilterProp="children"
                            disabled={balanceLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(calcModeData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="余额锁定值"
                        name="lockedBalance"
                        tooltip='余额锁定值，如是比例值: 0.05 = 5%，1 = 100%'
                        rules={[{ required: !balanceLock, message: '请输入余额锁定值!' }]}>
                        <InputNumber
                            disabled={balanceLock}
                            style={{ width: 100 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="余额解锁"
                        name="balanceExpiryRuleId"
                        tooltip='余额锁定到期规则'
                        rules={[{ required: !balanceLock, message: '请选择余额解锁!' }]}>
                        <Select
                            showSearch
                            placeholder="余额解锁"
                            optionFilterProp="children"
                            disabled={balanceLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(expiryRuleData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="赠送锁定"
                        name="isGiftsLock"
                        tooltip='是否使用赠送锁定功能'
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch checked={false}
                            onChange={(e) => { setGiftsLock(!e) }}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="赠送模式"
                        name="giftsCalcModeId"
                        tooltip='锁定赠送的计算模式'
                        rules={[{ required: !balanceLock, message: '请选择赠送模式!' }]}>
                        <Select
                            showSearch
                            placeholder="赠送模式"
                            optionFilterProp="children"
                            disabled={giftsLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(calcModeData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="赠送锁定值"
                        name="lockedGifts"
                        tooltip='赠送锁定值，如是比例值: 0.05 = 5%，1 = 100%'
                        rules={[{ required: !giftsLock, message: '请输入赠送锁定值!' }]}>
                        <InputNumber
                            disabled={giftsLock}
                            style={{ width: 100 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="赠送解锁"
                        name="giftsExpiryRuleId"
                        tooltip='赠送锁定到期规则'
                        rules={[{ required: !giftsLock, message: '请选择赠送解锁!' }]}>
                        <Select
                            showSearch
                            placeholder="赠送解锁"
                            optionFilterProp="children"
                            disabled={giftsLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(expiryRuleData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={4}>
                    <Form.Item
                        label="积分锁定"
                        name="isPointsLock"
                        tooltip='是否使用积分锁定功能'
                        valuePropName="checked"
                        initialValue={false}>
                        < Switch checked={false}
                            onChange={(e) => { setPointsLock(!e) }}
                            checkedChildren="是"
                            unCheckedChildren="否" />
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="积分模式"
                        name="pointsCalcModeId"
                        tooltip='锁定积分的计算模式'
                        rules={[{ required: !pointsLock, message: '请选择积分模式!' }]}>
                        <Select
                            showSearch
                            placeholder="积分模式"
                            optionFilterProp="children"
                            disabled={pointsLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(calcModeData)}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={6}>
                    <Form.Item
                        label="积分锁定值"
                        name="lockedPoints"
                        tooltip='积分锁定值，如是比例值: 0.05 = 5%，1 = 100%'
                        rules={[{ required: !pointsLock, message: '请输入积分锁定值!' }]}>
                        <InputNumber
                            disabled={pointsLock}
                            style={{ width: 100 }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label="积分解锁"
                        name="pointsExpiryRuleId"
                        tooltip='积分锁定到期规则'
                        rules={[{ required: !pointsLock, message: '请选择积分解锁!' }]}>
                        <Select
                            showSearch
                            placeholder="积分解锁"
                            optionFilterProp="children"
                            disabled={pointsLock}
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(expiryRuleData)}
                        </Select>
                    </Form.Item>
                </Col>

            </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;